import { Button, Checkbox, Divider, FormControlLabel, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import './Login.scss'
import logo from '../assets/Logo.png'
import { BootstrapInput } from '../theme/theme';
import { useAppDispatch, useAppSelector } from '../store/hooks/hooks';
import { useNavigate } from 'react-router-dom';
import { getToken } from '../utils/helperFunction';
import { LoginThunk } from '../store/thunk/actionThunk';
import { LoadingButton } from '@mui/lab';
import { StudentActions } from '../store/StudentAction';
import MessageSnackbar from '../utils/snackBar/snackBar';
import background from "../assets/background2.png"


const Login = () => {
    const [userName, setUserName] = useState<string>("")
    const [password, setPassword] = useState<string>("")
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { token, loginFailed, loading } = useAppSelector((state) => state.auth)
    useEffect(() => {
        if (token || Object.keys(getToken() || {}).length > 0) {
            navigate('/dashboard')
        }
    }, [])

    const handleSubmit = async (e: any) => {
        e.preventDefault()
        await dispatch(LoginThunk({ email: userName, password: password })).then(e => {
            if (e.payload) {
                navigate('/dashboard')
            }
            else {
                dispatch(StudentActions.setMessage("Login Failed,Please try again later."))
            }
        })
    }


    return (
        <div className="fadedown loginOuterContainer">
            <div>
                <div className='p-2 navbarContainer'>
                    <img src={logo} alt="logo Icon" style={{
                        height: '30px'
                    }}></img>
                </div>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    alignItems: 'center',
                    height: '100vh'
                }}> 
                    <div className='formContainer'>
                        <h1 className='title'>Log in</h1>
                        <h2 className='subTitle gray-color body-p'>Welcome to placementplus,please put your login credentials below to start using the app.</h2>
                        <form onSubmit={handleSubmit}>
                            <div className='align-items-center flex justify-content-between m-2 my-4'>
                                <label>E-mail</label>
                                <BootstrapInput id="userName-input" value={userName} onChange={(e) => {
                                    setUserName(e.target.value)
                                }} />
                            </div>
                            <div className='align-items-center flex justify-content-between m-2 my-4'>
                                <label>Password</label>
                                <BootstrapInput id="password-input" type='password' value={password} onChange={(e) => {
                                    setPassword(e.target.value)
                                }} />
                            </div>
                            <div className='align-items-center flex justify-content-end m-2  my-4'>
                                <Typography component="p" color="primary" className='body-p'>
                                    Forgot Password?
                                </Typography>
                            </div>
                            <Divider></Divider>
                            <div className='align-items-center flex justify-content-between m-2 my-4'>
                                <FormControlLabel label="Remember Me" className='gray-color body-p' control={<Checkbox aria-label='rememberMeCheckBox' />}></FormControlLabel>
                                <LoadingButton onClick={handleSubmit} loading={loading} variant="contained">
                                    Log In
                                </LoadingButton>
                            </div>
                            <div className='align-items-center flex justify-content-center m-2 my-4'>
                                <Typography component="p" className='gray-color body-p'>
                                    Don't have an account?
                                </Typography>
                                <Typography component="p" className='font-weight-700 body-p' color="primary">
                                    Sign Up
                                </Typography>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className='secondContainer p-5 text-white'>
                <h1 className='font-AudioWide title'>Welcome to your Placement Portal</h1>
                <h2 className='subTitle subTitleImage'>Now,you can empower your year in industry with your own personlized dashboard and other features.</h2>
                <img src={background} className="imagePlacement m-2"></img>
            </div>
            <MessageSnackbar></MessageSnackbar>
        </div>

    )

}
export default Login;